import { filters, useFilter } from '@ui/utils/filters';
import { useCallback } from 'react';

import { CardView, TopUpTab } from './types';

export const useCdcCardView = () => {
  const viewFilter = useFilter(filters.cdcCardView, undefined);
  const topUpTabFilter = useFilter(filters.topUpTab, undefined);
  return {
    view:
      viewFilter.filterValue === 'second' ? CardView.Second : CardView.First,
    setView: useCallback(
      (view: CardView) => {
        viewFilter.updateFilter(
          view === CardView.Second ? 'second' : undefined,
          undefined,
          false,
        );
      },
      [viewFilter],
    ),
    topUpTab:
      topUpTabFilter.filterValue === 'history'
        ? TopUpTab.History
        : TopUpTab.TopUp,
    setTopUpTab: useCallback(
      (tab: TopUpTab) => {
        topUpTabFilter.updateFilter(
          tab === TopUpTab.History ? 'history' : undefined,
          undefined,
          false,
        );
      },
      [topUpTabFilter],
    ),
  };
};
